/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import * as storageUtils from './storageUtils';

export function checkForAuthCallback(search: URLSearchParams) {
    const code = new URLSearchParams(search).get('code');
    storageUtils.setItem('code', code);
    const state = new URLSearchParams(search).get('state');
    storageUtils.setItem('state', state);
    return !!code && !!state;
}

export function getUrlParamValue(search: string, paramName: string) {
    return new URLSearchParams(search).get(paramName);
}

export function hasValidCookie() {
    const name = 'JSESSIONID';
    const matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}
